/**
 * ProductService
 * Service for Product entity operations
 * Route: api/products
 * Controller: ProductsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProductService
 * Handles product CRUD operations and product-specific queries
 * Maps to /api/products endpoint
 */
export class ProductService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProductService.DEFAULT_SERVICE_PATH,
            basePath: ProductService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== FILTERED LIST ====================
    /**
     * Get all products with optional type filter
     * GET /api/products?typeId={typeId}
     * @param typeId - Optional product type ID
     * @returns Array of product model views
     */
    async getAll(typeId) {
        const response = await this.getAllRaw(typeId);
        return response.data ?? [];
    }
    /**
     * Get all products with optional type filter (raw)
     * @param typeId - Optional product type ID
     * @returns ResponseData with product model views
     */
    getAllRaw(typeId) {
        const url = this.buildUrlWithParams(undefined, { typeId });
        return this.http.get(url);
    }
    // ==================== SEARCH ====================
    /**
     * Search products by name or product code
     * GET /api/products/search?term={term}
     * @param term - Search keyword
     * @returns Array of matching product model views
     */
    async search(term) {
        const response = await this.searchRaw(term);
        return response.data ?? [];
    }
    /**
     * Search products by name or code (raw)
     * @param term - Search keyword
     * @returns ResponseData with matching product model views
     */
    searchRaw(term) {
        const endpoint = this.getEndpoint('search', 'search');
        const url = this.buildUrlWithParams(endpoint, { term });
        return this.http.get(url);
    }
    // ==================== DELETE ====================
    /**
     * Delete a product
     * DELETE /api/products/{id}
     * @param id - Product ID
     * @returns True if deleted successfully
     */
    async delete(id) {
        const response = await this.deleteRaw(id);
        return response.success;
    }
    /**
     * Delete a product (raw)
     * @param id - Product ID
     * @returns ResponseData with deletion status
     */
    deleteRaw(id) {
        const url = this.buildUrl(String(id));
        return this.http.delete(url);
    }
}
ProductService.DEFAULT_SERVICE_PATH = 'products';
ProductService.BASE_PATH = 'api/products';
//# sourceMappingURL=ProductService.js.map